export const state = () => ({
  menuRecommendation: null,
  menuRecommendationList: [],
  periodEngineeringProfitability: null,
  isEngineeringProfitabilityLoading: 0,
});
